/**
 * Mindtime user portal branding (logos, login colors, page-title prefix).
 * Org white-label is separate (post-login).
 */

export type ProductBrand = 'mindtime';

export const isMindtimeProduct = true;

export const productBrand: ProductBrand = 'mindtime';

export const defaultLogoSrc = '/static/logo-mindtime.svg';

export const loginLogoSrc = '/static/logo-mindtime.svg';

export const loginPanelBgColor = '#1BB4EB';

/** White pad so the Mindtime mark stays visible on the brand-blue panel. */
export const loginLogoBoxSx = {
  bgcolor: 'white',
  borderRadius: '12px',
  p: 1,
  display: 'inline-flex',
  lineHeight: 0,
};

export const productLogoAlt = 'Mindtime';

const htmlTitlePrefix = 'Mindtime User Portal';

export const getPageTitle = (suffix: string): string =>
  `${htmlTitlePrefix} | ${suffix}`;
